import { useMemo } from "react";
import moment from "moment";

import { hasImage } from "../../../../../utils";
import { useResponsive } from "../../../../../hooks/useResponsive";

export function useFeedActorMeta({ user, date, mobileFormat, desktopFormat }) {
  const isMobile = useResponsive("down", "md");

  const actor = useMemo(
    () => ({
      username: user?.username || "",
      userImage: user?.user_image,
      profileColor: user?.profile_color || user?.user_profile_color,
    }),
    [user]
  );

  const avatarStyles = useMemo(
    () =>
      !hasImage(actor.userImage)
        ? {
            bgcolor: actor.profileColor?.background || "",
            color: actor.profileColor?.text,
          }
        : {},
    [actor.profileColor, actor.userImage]
  );

  const formattedDate = useMemo(
    () =>
      moment
        .utc(date)
        .local()
        .format(
          isMobile
            ? mobileFormat || "MMM D, YYYY [at] h:mm A"
            : desktopFormat || "MMMM D, YYYY [at] h:mm A"
        ),
    [date, desktopFormat, isMobile, mobileFormat]
  );

  return {
    actor,
    avatarStyles,
    formattedDate,
    isMobile,
  };
}
